export default __webpack_public_path__ + "static/4-6237fc553108c6d63fcfb2b443f610d7.png";